var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.221886mm",
    height: "78.221886mm",
    viewBox: "0 0 78.221886 78.221886",
    id: "svg3108",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-51.202763,-72.621029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 90.313705,
    cy: 111.73197,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 4.07829
    },
    d: "m 68.875333,133.99164 c -0.888,-0.17459 -1.092748,-0.34472 -1.585858,-1.31785 l -0.395104,-0.77969 v -11.41296 -11.41297 l 1.045672,-3.2335 c 0.575121,-1.77841 1.757533,-5.47247 2.627584,-8.208996 1.89858,-5.971514 2.355954,-6.943844 3.64713,-7.7534 l 0.917747,-0.57542 15.171218,0.04534 15.171208,0.04534 0.65255,0.352751 c 0.35889,0.194013 0.89112,0.601286 1.18276,0.905051 0.6137,0.639242 0.77332,1.084536 4.13973,11.548004 l 2.28307,7.09621 -0.053,11.41921 c -0.0591,12.70527 0.016,11.88786 -1.18772,12.94472 l -0.58497,0.51361 h -2.04908 c -2.30754,0 -2.70577,-0.1337 -3.40539,-1.14327 -0.34907,-0.50368 -0.41559,-0.82823 -0.51056,-2.49116 l -0.10922,-1.91203 H 90.278863 74.724678 l -0.0053,0.85644 c -0.0094,1.51201 -0.281511,3.09108 -0.60878,3.53309 -0.699388,0.94455 -1.25502,1.15849 -2.95811,1.13906 -0.861526,-0.0103 -1.886227,-0.0808 -2.277113,-0.15759 z m 8.704142,-14.17155 c 0.74796,-0.3214 1.591613,-1.21318 1.981515,-2.09455 0.3489,-0.78869 0.362559,-2.6936 0.02489,-3.47233 -0.6626,-1.52815 -1.98665,-2.43512 -3.554895,-2.43512 -1.659726,0 -2.853671,0.74257 -3.530301,2.19562 -0.68546,1.47201 -0.486295,3.41891 0.479248,4.68481 1.13974,1.49431 2.7936,1.89758 4.599543,1.12157 z m 28.862405,-0.14806 c 1.3524,-0.72591 2.17109,-2.38296 2.00044,-4.04888 -0.23565,-2.3005 -1.76504,-3.79323 -3.89476,-3.80148 -1.17538,-0.005 -1.6899,0.19203 -2.47142,0.94414 -1.01309,0.97499 -1.31365,1.70444 -1.32349,3.21214 -0.007,1.1513 0.0487,1.40827 0.4767,2.1811 0.57644,1.04078 1.2984,1.63244 2.34031,1.91793 0.9702,0.26586 1.85488,0.14112 2.87222,-0.40495 z m 1.9516,-13.57281 c 0.0499,-0.05 -0.76985,-2.89449 -1.82172,-6.321169 l -1.91248,-6.230322 -14.385346,-1.73e-4 c -13.559119,-1.6e-4 -14.390259,0.01621 -14.47079,0.285309 -0.04698,0.157013 -0.896141,2.937039 -1.887001,6.177835 -0.990862,3.24079 -1.80157,5.93639 -1.80157,5.99019 0,0.0538 0.935968,0.12306 2.079928,0.15384 3.43212,0.0924 34.100949,0.0427 34.198979,-0.0554 z",
    id: "path2485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.f2c3368bdacc3371966ea4d51ee3804d.svg";
export { ForwardRef as ReactComponent };